import { useContext } from 'react';

import { StepperApiContext } from '../Context';

const useStepperApi = () => {
  const api = useContext(StepperApiContext);
  return api;
};

export default useStepperApi;
